// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error_text {
	color: #b10a0a;
}

.error_text::before {
	display: inline;
	content: "⚠ ";
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/error.css"],"names":[],"mappings":"AAAA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,aAAa;AACd","sourcesContent":[".error_text {\n\tcolor: #b10a0a;\n}\n\n.error_text::before {\n\tdisplay: inline;\n\tcontent: \"⚠ \";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
